/*
 * Copyright (c) 2018. CPP, Inc. All rights reserved.
 * Also protected by Patent Pending: 15/916,593
 */

import cx from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import styles from './styles.module.css'

const SiteTitle = ({ className, title }) => {
  return (
    <header className={cx(className, styles.SiteTitle, 'centeringFlex')}>
      <h1>{title}</h1>
    </header>
  )
}

SiteTitle.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
}

export default SiteTitle
